document.addEventListener('DOMContentLoaded', () => {
  const feedbackCard = document.querySelector('.feedback__card')
  const feedbackForm = document.querySelector('.feedback__form')

  if(feedbackCard && feedbackForm) {
    const feedbackButtons = feedbackCard.querySelectorAll('.feedback__button')
    const feedbackChoice = feedbackForm.querySelector('.feedback__choice')
    const feedbackFormTitle = feedbackForm.querySelector('.feedback__title')
    const feedbackFormTextarea = feedbackForm.querySelector('.feedback__textarea')
    if(feedbackButtons && feedbackChoice && feedbackFormTextarea && feedbackFormTitle) {
      feedbackButtons.forEach(button => {
        button.addEventListener('click', () => {
          const value = button.value
          feedbackChoice.setAttribute('value', value)
          const text = value.toLowerCase() === 'yes' ? 'Благодарим! А что понравилось больше всего? ' : 'Что нам следует улучшить? Поделитесь мнением '
          const placeholder = value.toLowerCase() === 'yes' ? 'Мне понравилось... ' : 'Мне не понравилось...'
          feedbackFormTitle.innerHTML = text
          feedbackFormTextarea.setAttribute('placeholder', placeholder)
          feedbackForm.classList.add('feedback__form--view')
        })
      })
    }
  }
})
